import RetailerCredentialsForm from 'pages/SalesChannels/Forms/RetailerCredentialsForm';
import StoreBasicConfigForm from 'pages/SalesChannels/Forms/StoreBasicConfigForm';
import AkinonForm from 'pages/SalesChannels/Stores/AkinonForm';
import AmazonForm from 'pages/SalesChannels/Stores/AmazonForm';
import BigcommerceForm from 'pages/SalesChannels/Stores/BigcommerceForm';
import ChannelEngineForm from 'pages/SalesChannels/Stores/ChannelEngineForm';
import FatherShopsForm from 'pages/SalesChannels/Stores/FatherShopsForm';
import FoodicsForm from 'pages/SalesChannels/Stores/FoodicsForm';
import IkasForm from 'pages/SalesChannels/Stores/IkasForm';
import MagentoForm from 'pages/SalesChannels/Stores/MagentoForm';
import MiraklForm from 'pages/SalesChannels/Stores/MiraklForm';
import NoonForm from 'pages/SalesChannels/Stores/NoonForm';
import OpenCartForm from 'pages/SalesChannels/Stores/OpenCartForm';
import PikForm from 'pages/SalesChannels/Stores/PikForm';
import PrestashopForm from 'pages/SalesChannels/Stores/PrestashopForm';
import SalesforceForm from 'pages/SalesChannels/Stores/SalesforceForm';
import SallaAutomationForm from 'pages/SalesChannels/Stores/Salla/SallaAutomationForm';
import SallaForm from 'pages/SalesChannels/Stores/Salla/SallaForm';
import SallaPrivateAppForm from 'pages/SalesChannels/Stores/Salla/SallaPrivateAppForm';
import SallaWebhookForm from 'pages/SalesChannels/Stores/Salla/SallaWebhookForm';
import ShahbandrForm from 'pages/SalesChannels/Stores/ShahbandrForm';
import ShopifyForm from 'pages/SalesChannels/Stores/ShopifyForm';
import SyliusForm from 'pages/SalesChannels/Stores/SyliusForm';
import TicimaxForm from 'pages/SalesChannels/Stores/TicimaxForm';
import TrendyolForm from 'pages/SalesChannels/Stores/TrendyolForm';
import TsoftForm from 'pages/SalesChannels/Stores/TsoftForm';
import WoocommerceForm from 'pages/SalesChannels/Stores/WoocommerceForm';
import ZidForm from 'pages/SalesChannels/Stores/ZidForm';
import ZohoForm from 'pages/SalesChannels/Stores/ZohoForm';

import PATHS from './paths';

export const cardImages = {
	americanexpress: 'https://storage.googleapis.com/tryoto-public/credit-cards/americanExpress.svg',
	applepay: 'https://storage.googleapis.com/tryoto-public/credit-cards/applePay.svg',
	mada: 'https://storage.googleapis.com/tryoto-public/credit-cards/mada.svg',
	mastercard: 'https://storage.googleapis.com/tryoto-public/credit-cards/mastercard.svg',
	visa: 'https://storage.googleapis.com/tryoto-public/credit-cards/visa.svg'
};

export const PAYMENT_GATEWAY_TYPE = {
	PAYTR: 'PAYTR',
	TAP_PAYMENT_UAE: 'TAP_PAYMENT_UAE',
	TAP_PAYMENT: 'TAP_PAYMENT'
};

export const PAYMENT_METHODS = {
	BANK_CARD: 'bankCard',
	CREDIT_CARD: 'creditCard',
	SAVED: 'savedPaymentMethod',
	APPLE_PAY: 'applePay',
	COD: 'cod',
	OTO_CREDIT: 'otoCredit'
};

export const DYNAMICLISTS = {
	ACCESS_CONTROL: 'access-control',
	ENUM_MANAGEMENT: 'enum-management',
	LANGUAGE_RESOURCE_MANAGEMENT: 'language-resource-management',
	CLIENT_LISTING: 'client-listing',
	COHORT_AGGREGATOR_ANALYSIS: 'aggregator',
	COHORT_INTEGRATOR_ANALYSIS: 'integrator',
	COUNTRIES_MANAGEMENT: 'countries-management',
	MODULES: 'modules',
	OTHER_INTEGRATIONS_ADMIN: 'other-integrations-admin',
	PACKAGES: 'packages-list',
	ADMIN_SALES_CHANNELS: 'admin/sales-channels',
	STORY_MANAGEMENT: 'story-management',
	SUBSCRIPTION_LIST: 'subscription-list',
	SUBSCRIPTION_TRANSACTIONS_LISTING: 'subscription-transactions',

	ALL_ORDERS: 'all-orders',
	AWAITING_PICKUP: 'awaiting-pickup',
	CANCELED_ORDERS: 'canceled-orders',
	CURRENTLY_SHIPPING: 'currently-shipping',
	DELIVERED_ORDERS: 'delivered-orders',
	ONHOLD_ORDERS: 'onhold-orders',
	PENDING_ORDERS: 'pending-orders',
	RETURNED_ORDERS: 'returned-orders',
	WH_HISTORY: 'wh-history',
	WH_PENDING_ORDERS: 'wh-pending-orders',
	WH_SHIPMENT_INPROGRESS: 'wh-shipment-inprogress',
	WH_SHIPMENT_ONHOLD: 'wh-shipment-onhold',
	WH_WAITING_PICKUP: 'wh-waiting-pickup',
	BR_WAITING_FOR_DRIVER: 'br-waiting-for-driver',
	BR_PENDING_ORDERS: 'br-pending-orders',
	BR_RETURNED: 'br-returned',
	BR_DELIVERED: 'br-delivered',
	BR_CANCELED: 'br-canceled',
	BR_UNASSIGNED: 'br-unassigned',
	BR_SHIPMENT_INPROGRESS: 'br-shipment-in-progress',
	LAST_10_ORDERS: 'last10Orders',
	DC_PERFORMANCE: 'dcPerformance',
	DRIVER_PERFORMANCE: 'driverPerformance',
	USERS: 'users',
	WMS_USERS: 'wms-users',
	PRODUCTS: 'products',
	BANKS: 'banks',
	PRODUCT_SYNC_LOGS: 'product-sync-logs',
	ROLE_TEMPLATES: 'role-templates',
	BRANCHES: 'branches',
	WAREHOUSES: 'warehouses',
	BRANDS: 'brands',
	INVENTORY: 'inventory',
	BIN_INVENTORY: 'binInventory',
	CUSTOMIZABLE_PAGES: 'customizable-pages',
	GLOBAL_INVENTORY: 'global-inventory',
	SMS_SETTINGS: 'sms-settings',
	SHIPPING_PARTNER_CITY_COVERAGE: 'shipping-partner-city-coverage',
	AUTOMATION: 'automation',
	HISTORY_ORDERS: 'history-orders',
	PROCESSING_ORDERS: 'processing-orders',
	CUSTOMER_FEEDBACKS: 'customer-feedbacks',
	FAILED_DELIVERY_ORDERS: 'failed-delivery-orders',
	BANK_TRANSFER: 'bank-transfer',
	CLIENT_TRANSACTIONS: 'client-transactions',
	REFUND_TRANSACTIONS_FOR_CANCEL_FRAUD: 'refund-transactions-for-cancel-fraud',
	APPROVED_COD_REPORTS: 'approved-cod-reports',
	CASH_DEPOSITED_REPORTS: 'cash-deposited-reports',
	NEW_COD_REPORTS: 'new-cod-reports',
	PAYABLE_COD_DETAILS: 'payable-cod-details',
	RECEIVABLE_COD_DETAILS: 'receivable-cod-details',
	NEW_RECEIVABLE_REPORTS: 'new-receivable-reports',
	NO_CONFLICT: 'no-conflict',
	RECEIVED_OTO_BANK_FROM_DC: 'received-oto-bank-from-dc',
	RECONCILED_ORDERS: 'reconciled-orders',
	WAITING_RECONCILATION_ORDERS: 'waiting-reconcilation-orders',
	ALL_WITHDRAWALS: 'all-withdrawals',
	BANK_TRANSFER_FAILED: 'bank-transfer-failed',
	BANK_TRANSFER_PROCESSING: 'bank-transfer-processing',
	UNIT_ECONOMICS_DC_PL_ANALYSIS: 'unit-economics-dashboard-delivery-company-pl-analysis',
	UNIT_ECONOMICS_DC_PROFITABILITY: 'unit-economics-dashboard-delivery-company-profitability',
	UNIT_ECONOMICS_CLIENT_ANALYSIS_LIST: 'unit-economics-dashboard-client-analysis-list',
	UNIT_ECONOMICS_AGGREGATOR_INVOICE_LIST: 'unit-economics-dashboard-aggregator-invoice-list',
	AUTOMATION_ERROR_LOGS: 'automation-error-logs',
	AUTOMATION_SUCCESS_LOGS: 'automation-success-logs',
	EMAIL_LOGS: 'email-logs',
	INVENTORY_SYNC_LOGS: 'inventory-sync-logs',
	PICKUP_REQUEST_LOGS: 'pickup-request-logs',
	SHIPMENT_ERROR_LOGS: 'shipment-error-logs',
	SMS_LOGS: 'sms-logs',
	UPDATE_ERROR_LOGS: 'update-error-logs',
	UPDATE_SUCCESS_LOGS: 'update-success-logs',
	WEBHOOKS: 'webhooks',
	WEBHOOK_ERROR_LOGS: 'webhook-error-logs',
	BM_INVENTORY: 'bm-inventory',
	BM_ORDERS: 'bmOrders',
	BM_PRODUCTS: 'brand-manager-products',
	OTO_FLEX_DRIVERS: 'drivers',
	OTO_FLEX_HISTORY_ORDERS: 'oto-flex-history-orders',
	OTO_FLEX_PROCESSING_ORDERS: 'oto-flex-processing-orders',
	OTO_FLEX_UNASSIGNED_ORDERS: 'oto-flex-unassigned-orders',
	ORDER_AUTOMATION: 'order-automation',
	CLOSED_SHIPMENTS: 'closed-shipments',
	OTO_DELIVERY_PRICES: 'oto-delivery-prices',
	OTO_MARGIN_LIST: 'oto-margin',
	RECONCILIATION_LIST: 'reconciliation',
	SHIPPING_CONTRACTS: 'shipping-contracts',
	SPECIAL_CONTRACT_TERMS: 'special-contract-terms',
	SUCCESS_INSTRUCTIONS: 'success-instructions',
	SHIPPING_PARTNERS_BULLET_KM_SLA: 'bullet-km-sla',
	SHIPPING_PARTNERS_CITY_BASED_SLA: 'city-based-sla-list',
	SHIPPING_PARTNERS_KM_BASED_SLA: 'km-based-sla-list',
	SHIPPING_PARTNERS_TIER_BASED_SLA: 'tier-based-sla-list',
	SHIPPING_PARTNERS_DISTRICT_BASED_SLA: 'district-based-sla-list',
	SHIPPING_PARTNERS_COUNTRY_BASED_SLA: 'country-based-sla-list',
	PRICE_CONFIGURATIONS_CITY_BASED_PRICES: 'city-based-prices',
	PRICE_CONFIGURATIONS_KM_BASED_PRICES: 'km-based-prices',
	PRICE_CONFIGURATIONS_TIER_BASED_PRICES: 'tier-based-prices',
	PRICE_CONFIGURATIONS_WEIGHT_BASED_PRICES: 'weight-based-prices',
	PRICE_CONFIGURATIONS_WEIGHT_COUNTRY_BASED_PRICES: 'weight-country-based-prices',
	PRICE_CONFIGURATIONS_BULLET_KM_SLA: 'bullet-km-sla',
	PRICE_CONFIGURATIONS_CITY_BASED_SLA: 'city-based-sla',
	PRICE_CONFIGURATIONS_COUNTRY_BASED_SLA: 'country-based-sla',
	PRICE_CONFIGURATIONS_DISTRICT_BASED_SLA: 'district-based-sla',
	PRICE_CONFIGURATIONS_KM_BASED_SLA: 'km-based-sla',
	PRICE_CONFIGURATIONS_TIER_BASED_SLA: 'tier-based-sla',
	PRICE_CONFIGURATIONS_WEIGHT_CORR_CLOSED: 'weight-corr-closed',
	PRICE_CONFIGURATIONS_WEIGHT_CORR_OPEN: 'weight-corr-open',
	ATTRIBUTES_GROUPS: 'attributes-groups',
	PRODUCT_ATTRIBUTES: 'product-attributes',
	RETURNS: 'returns',
	BRANCH_REPORT: 'reports/branch-reports/branch-report',
	BRANCH_DAILY_STAFF_REPORT: 'reports/branch-reports/branch-daily-staff-report',
	OTO_FLEX_DRIVER_DETAILS_REPORT: 'reports/otoflex-reports/driver-details',
	OTO_FLEX_DRIVER_SUMMARY_REPORT: 'reports/otoflex-reports/driver-summary',
	OTO_FLEX_TRANSACTION_REPORT: 'reports/otoflex-report/transaction-report',
	BIN_TRANSACTIONS: 'binTransactions',
	DAILY_STAFF: 'dailyStaff',
	INVENTORY_TRANSACTIONS: 'inventoryTransactions',
	PACKING_STATUS_REPORTS: 'packingStatusReports',
	ORDER_BASED_TRANSACTION_REPORTS: 'orderBasedTransactionReports',
	PICKING_EXCEPTIONS: 'pickingExceptions',
	STOCK_UPDATE: 'stockUpdate',
	WAVE_BASED_TRANSACTION: 'waveBasedTransaction',
	AGED_ORDERS_REPORT: 'reports/order-reports/aged-orders-report',
	CUSTOMER_FEEDBACKS_REPORT: 'reports/other-reports/customer-feedbacks',
	CUSTOM_REPORT_1: 'reports/order-reports/custom-report-1',
	DAILY_ORDER_STATS_REPORT: 'reports/order-reports/daily-order-stats',
	ORDERS_BY_PRODUCT_REPORT: 'reports/order-reports/orders-by-product-report',
	ORDER_STATUS_LOGS_REPORT: 'reports/order-reports/order-status-logs',
	RESENT_ORDERS_REPORT: 'reports/order-reports/resent-orders',
	SALES_BY_SKU_REPORT: 'reports/order-reports/sales-by-sku',
	SLA_BREACHES_REPORT: 'reports/other-reports/sla-breaches-report',
	TIME_STATS_REPORT: 'reports/other-reports/time-stats',
	DELIVERED_ORDERS_BY_CITY_BY_COURIER_REPORT: 'reports/shipment-reports/delivered-orders-by-city-by-courier',
	DELIVERY_ATTEMPT_REPORT: 'reports/shipment-reports/delivery-attempt-report',
	DELIVERY_COMPANY_REPORT_BY_CITY: 'reports/shipment-reports/delivery-company-report-by-city',
	FAILED_DELIVERY_REPORT: 'reports/shipment-reports/failed-delivery',
	PAID_COD_REPORTS: 'reports/shipment-reports/paid-cod',
	PAID_COD_ORDERS_LIST: 'paid-cod-orders-list',
	PICKUP_DELIVERY_REPORT: 'reports/shipment-reports/pickup-delivery-report',
	SHIPMENT_STATUS_REPORT: 'reports/shipment-reports/shipment-status-report',
	INTEGRATOR_SLA_REPORT: 'reports/shipment-reports/integrator-sla-report',
	AGGREGATOR_PROFIT_REPORT: 'reports/shipment-reports/aggregator-profit-report',
	STORE_LOCATION_LIST: 'store-location-list',
	AREA_SETTINGS: 'area-settings',
	CITY_GROUP_LIST: 'city-group',
	BLACKLISTED_CUSTOMER_LIST: 'blacklisted-customer',
	BOX_LIST: 'box-settings',
	EMAIL_ACCOUNTS: 'email-accounts',
	EMAIL_SETTINGS: 'email-settings',
	EXPORT_LOGS: 'export-logs',
	IMPORT_LOGS: 'import-logs',
	INVOICE_LIST: 'invoice',
	INVOICE_DETAILS_LIST: 'invoice-details',
	NEW_RECORDS: 'new-records',
	NOT_INVOICED_ORDERS: 'not-inoviced-orders',
	PRICE_NOT_FOUND_ORDERS: 'price-not-found-orders',
	COD_WALLET_LIST: 'cod-wallet-list',
	COD_DETAILS_LIST: 'cod-details-list',
	REFERRALS: 'referrals',
	CREDIT_TRANSACTIONS: 'credit-transactions',
	FREE_CREDIT_TRANSACTIONS: 'free-credit-transactions',
	SUBSCRIPTION_TRANSACTIONS: 'subscription-transactions',
	PREDEFINED_MESSAGES: 'predefined-messages',
	REASON_CONFIG_LIST: 'reason-config',
	INVOICE_CHECKER_HISTORY_LIST: 'invoice-checker-history',
	SHIPPING_PRICES: 'shipping-prices',
	SHIPPING_PRICE_TRANSACTIONS: 'shipping-price-transactions',
	WHATSAPP_SETTINGS: 'whatsapp-settings',
	WHATSAPP_TEMPLATES: 'whatsapp-templates',
	AGGREGATOR_AGING_SHIPMENTS: 'aggregator-aging',
	DELIVERY_COMPANY_SCORE_LIST: 'delivery-company-score-list',
	OPERATION_ALL_ORDERS: 'operation-all-orders',
	OPERATION_NEED_ACTION_SHIPMENT: 'operation-need-action-shipment',
	BULLET_TRACKING_LIST: 'bullet-tracking-list',
	OPERATION_PICKUP_DELIVERY_REPORT: 'pickup-delivery-report',
	PICKUP_REQUESTS: 'pickup-requests',
	PROMO_TRANSACTIONS: 'promo-transactions',
	PROMOTIONS: 'promotions',
	TIME_STATS_FOR_OPERATION: 'time-stats-for-operation',
	DELIVERY_ATTEMPT_REPORT_LIST: 'delivery-attempt-report-list',
	ZERO_DC_DETAILED_LIST: 'zero-dc-detailed-list',
	ZERO_DC_GROUPED_LIST: 'zero-dc-grouped-list',
	FEASIBILITY_RULES: 'feasibility-rules',
	PRIORITY_RULES: 'priority-rules',
	DELIVERY_SLOT_MANAGEMENT: 'delivery-slot-management',
	CITIES: 'cities',
	COUNTRIES: 'countries',
	DISTRICTS: 'districts',
	STATES: 'states',
	GOVERNORATES: 'governorates',
	CLIENT_USERS: 'client-users',
	DC_PICKUP_LOCATION_LIST: 'dc-pickup-location',
	DELIVERY_COMPANIES: 'delivery-companies',
	BINS: 'bins',
	USER_GROUPS: 'user-groups',
	VENDORS: 'vendors',
	ZONES: 'zones',
	INBOUND_ORDERS: 'inbound-orders',
	OUTBOUND_ORDERS: 'outbound-orders',
	PACKING_LIST: 'packingList',
	PUTAWAY_LIST: 'putawayList',
	WMS_RETURNED_LIST: 'wmsReturnList',
	WAVE_LIST: 'waveList',
	SORTING_LIST: 'sortingList',
	WAVE_PILOT_LIST: 'wavePilotList',
	PURCHASE_ORDERS: 'purchase-orders',
	IMPORT_ORDERS: 'imports',
	DELIVERY_COMPANY_SETTINGS: 'delivery-company-settings',
	PICKUP_CITIES: 'pickup-cities',
	POLYGON_COVERAGE: 'polygon-coverage',
	OTOLINK_ALL: 'otolink-all',
	OTOLINK_USED: 'otolink-active',
	OTOLINK_TRANSACTIONS: 'otolink-transactions',
	OTOLINK_ORDERS: 'otolink-orders',
	DC_STATUSES: 'dc-statuses',
	DC_STATUS_GROUPS: 'dc-status-groups',
	STATUS_GROUP_TRANSITIONS: 'status-group-transitions',
	DC_STATUS_MAPPING_LIST: 'dc-status-mapping-list',
	MISSING_MAPPING_STATUSES_GROUPED: 'missing-mapping-statuses-grouped',
	MISSING_MAPPING_STATUSES_DETAILED: 'missing-mapping-statuses-detailed',
	EXTRA_CREDITS_SMB: 'extra-credits-smb',
	EXTRA_CREDITS_ENTERPRISE: 'extra-credits-enterprise',
	CONTRACTED_SHIPMENTS: 'contracted-shipments',
	NEIGHBORHOODS: 'neighbourhoods',
	OTO_STORE_MY_ORDERS: 'otoStoreMyOrders',
	REFERRAL_LIST: 'referral-list',
	CREATE_SHIPMENT_ERROR_MAPPING: 'create-shipment-error-mapping-list',
	OTO_LINK_FINANCE_TRANSACTIONS: 'otolink-finance-transactions',
	HOME_PAGE_ANNOUNCEMENTS: 'home-page-announcements-management',
	SHIPMENT_ERROR_LOGS_BY_AI: 'shipment-error-logs-by-ai'
};

export const SalesChannelElementMapping = {
	MagentoForm,
	WoocommerceForm,
	ShopifyForm,
	RetailerCredentialsForm,
	ZidForm,
	OpenCartForm,
	SyliusForm,
	StoreBasicConfigForm,
	BigcommerceForm,
	ZohoForm,
	SalesforceForm,
	IkasForm,
	TicimaxForm,
	FatherShopsForm,
	TrendyolForm,
	TsoftForm,
	PrestashopForm,
	ChannelEngineForm,
	AkinonForm,
	SallaForm,
	SallaWebhookForm,
	SallaPrivateAppForm,
	SallaAutomationForm,
	ShahbandrForm,
	FoodicsForm,
	AmazonForm,
	PikForm,
	NoonForm,
	MiraklForm
};

export const ACCOUNT_TYPES = {
	PERSONAL: 'personal',
	FREELANCER: 'freelancer',
	COMPANY: 'company'
};
export const KYC_STATUS = {
	ACTIVE: 'active',
	PENDING: 'pending',
	NOT_APPROVED_BUSINESS: 'notApprovedBusiness',
	NOT_APPROVED_DOCUMENTS: 'notApprovedDocuments',
	REJECTED: 'rejected'
};

export const TEST_CARDS = {
	PAYTR: [
		{
			cardHolderName: 'OTO Test',
			cardNumber: '4355084355084358',
			expiryMonth: '12',
			expiryYear: '30',
			cvv: '000'
		},
		{
			cardHolderName: 'OTO Test',
			cardNumber: '5406675406675403',
			expiryMonth: '12',
			expiryYear: '30',
			cvv: '000'
		}
	],
	TAP_PAYMENT: [
		{
			cardHolderName: 'OTO Test',
			cardNumber: '5123450000000008',
			expiryMonth: '12',
			expiryYear: '30',
			cvv: '100'
		},
		{
			cardHolderName: 'OTO Test',
			cardNumber: '4508750015741019',
			expiryMonth: '12',
			expiryYear: '30',
			cvv: '100'
		}
	],
	TAP_PAYMENT_UAE: [
		{
			cardHolderName: 'OTO Test',
			cardNumber: '5123450000000008',
			expiryMonth: '12',
			expiryYear: '30',
			cvv: '100'
		},
		{
			cardHolderName: 'OTO Test',
			cardNumber: '4508750015741019',
			expiryMonth: '12',
			expiryYear: '30',
			cvv: '100'
		}
	]
};

export const MODULE_PATHS = {
	'aggregator-shipping': PATHS.AGGREGATOR_MODULE,
	'branch-module': PATHS.BRANCH_MODULE,
	'customizable-role': PATHS.ROLE_MODULE,
	'email-whatsapp': PATHS.EMAIL_WHATSAPP_MODULE,
	imports: PATHS.IMPORTS_MODULE,
	'multi-brand': PATHS.MULTI_BRAND_MODULE,
	'order-management': PATHS.ORDER_AUTOMATION_MODULE,
	'oto-flex': PATHS.OTO_FLEX_MODULE,
	'oto-inventory': PATHS.INVENTORY_MODULE,
	'oto-link': PATHS.OTO_LINK_MODULE,
	'product-information': PATHS.PRODUCT_MODULE,
	'sales-channel': PATHS.SALES_CHANNELS_MODULE,
	'shipping-automation': PATHS.SHIPPING_AUTOMATION_MODULE,
	'sms-module': PATHS.SMS_MODULE,
	'warehouse-module': PATHS.WAREHOUSE_MODULE,
	'customer-service': PATHS.CUSTOMER_SERVICE_MODULE,
	'warehouse-management-system': PATHS.WAREHOUSE_MANAGEMENT_MODULE,
	'shipping-accounting': PATHS.SHIPPING_ACCOUNTING_MODULE
};

export const PLATFORM = {
	web: 'web',
	desktop: 'desktop'
};
